/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

import { apiPost } from "@/domain/api/api.request"

/*
Auth
*/

export async function authorizationRequest(identityKey, password) {

    return apiPost("/api/auth/", {
        identityKey,
        password
    })

}